import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-hero" aria-label="Email signup and showcase">
        <div className="signup">
          <h2 className="signup-title">Connect.</h2>
          <p>depot@rivergrove.blog</p>
          <p>SSL MARKETS LIMITED</p>
          <p>
            FLAT/RM A, 9/F SILVERCORP INTERNATIONAL TOWER 707–713 NATHAN ROAD
            MONGKOK, KL
          </p>
        </div>
      </section>

      <div className="footer-links">
        <div className="links-inner">
          <div className="links-col">
            <h4>Company</h4>
            <ul>
              <li>
                <Link onClick={toTop} to="/about">
                  About
                </Link>
              </li>

              <li>
                <Link onClick={toTop} to="/terms">
                  Terms of service
                </Link>
              </li>
              <li>
                <Link onClick={toTop} to="/privacy">
                  Privacy
                </Link>
              </li>
            </ul>
          </div>

          <div className="links-col">
            <h4>Support</h4>
            <ul>
              <li>
                <Link onClick={toTop} to="/contact">
                  Contact us
                </Link>
              </li>

              <li>
                <Link onClick={toTop} to="/shipping">
                  Shipping and returns
                </Link>
              </li>
            </ul>
          </div>

          <div className="links-col follow">
            <h4>Follow Us</h4>
            <div className="socials">
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                youtube
              </a>

              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                facebook
              </a>

              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                twitter
              </a>

              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                instagram
              </a>

              <a
                href="https://www.pinterest.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Pinterest"
              >
                pinterest
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
